import React from 'react';
import PropTypes from 'prop-types';

import {Paper} from 'views/components';

const CardPaper = (props) => {
  const {children, sx, ...rest} = props;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        ...(sx ?? {}),
      }}
      {...rest}
    >
      {children}
    </Paper>
  );
};

CardPaper.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default CardPaper;
